
import Visual from 'vue-visual'
export default

	props:
		asset:
			type: Object
			required: true

	components: { Visual }

	computed:
		# Check if image is gif
		isImageGif: () ->	if @image then @image.mimeType == 'image/gif'

		image: ->	@asset.image

		# Make gif url
		gif: ->
			return unless @isImageGif
			imgixUrl = process.env.IMGIX_URL
			if imgixUrl then "#{imgixUrl}/#{@image.path}"
			else @image.url

		isLibraryVideo: ->
			return unless @asset
			!!@libraryVideo

		libraryVideo: ->
			return unless @asset
			@asset.libraryVideo

		landscapeVideo: ->
			return unless @asset
			libraryVideo = @asset.libraryVideo
			return @asset.video unless !!libraryVideo
			if libraryVideo.videoDesktop?.length then return libraryVideo.videoDesktop
			else if libraryVideo.videoMobile?.length then return libraryVideo.videoMobile

		portraitVideo: ->
			return unless @asset
			return @asset.video unless libraryVideo = @asset.libraryVideo
			if libraryVideo.videoMobile?.length then return libraryVideo.videoMobile
			else if libraryVideo.videoDesktop?.length then return libraryVideo.videoDesktop

	methods:
		playLibraryVideo: ->
			return unless @libraryVideo

			if window.innerWidth > 768
				mp4Video = @libraryVideo.videoDesktop[0]
			else
				mp4Video = @libraryVideo.videoMobile[0]

			if mp4Video then @$store.commit 'videoModal/play', {video: mp4Video, title: @libraryVideo.title, subtitles: @libraryVideo.subtitles, libraryVideoId: @libraryVideo.id }

